import React from 'react'

export const MenuToggle = ({
  toggleMenu,
  active,
  isDark,
}: {
  toggleMenu?: () => void
  active?: boolean
  isDark?: boolean
}) => {
  return (
    <div
      onClick={toggleMenu}
      className={`menu-toggle ${active ? `is-active` : ''} ${
        isDark ? `dark` : ''
      }`}
      role="button"
    >
      <span className="menu-toggle-box">
        <span className="menu-toggle-inner" />
      </span>
    </div>
  )
}
